// Solution -> https://stackoverflow.com/questions/9533106/detect-phone-vs-tablet
export const isMobile = (/mobile/i.test(navigator.userAgent) && !/ipad|tablet/i.test(navigator.userAgent))
export const isTablet = !isMobile
